var map = {
	"./certificate.svg": 6854,
	"./clipboard-info.svg": 5031,
	"./download-doc.svg": 6265,
	"./eye.svg": 9279,
	"./file-exe.svg": 1215,
	"./folder-big-orig.svg": 8301,
	"./folder-big.svg": 5771,
	"./folder-small.svg": 7915,
	"./folder-with-papers.svg": 97,
	"./form-on-laptop.svg": 2796,
	"./hammer.svg": 948,
	"./home.svg": 2781,
	"./layers.svg": 1457,
	"./logo-new2.svg": 7366,
	"./map-point.svg": 8837,
	"./missile-arrow.svg": 5822,
	"./people-connected.svg": 5990,
	"./react.svg": 7256,
	"./search.svg": 1238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;